export default __webpack_public_path__ + "assets/privacy-policy.948543bdc2e3e9d6efeb9876f5acb02d.pdf";